const initialStatePower = {
    list: [
        '1,5 kW',
        '2 kW',
        '2,5 kW',
        '3 kW',
        '3,5 kW',
        '4 kW',
        '4,5 kW',
        '5 kW',
        '5,5 kW',
        '6 kW',
        '7 kW',
        '8 kW',
        '9 kW',
        '10 kW',
        '15 kW',
        '20 kW',
        '25 kW',
        '30 kW',
    ]
}

export function powerReducer (state = initialStatePower, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}